<template>
  <div>
    <base-list-management ref="baseListManagementRef" :configData.sync="configData">
      <template #custom-operate>
        <div class="operation-box" v-if="judgePermission('lease_campaign_create')">
          <el-button type="primary" @click="doCreate">新建活动</el-button>
        </div>
      </template>
    </base-list-management>

    <CampaignDrawer
      :visible.sync="drawerVisible"
      :mode="drawerMode"
      :campaign-id="selectedCampaignId"
      @saved="onCampaignSaved"
    />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { configDataFn } from './leaseCampaignListConfig'
// eslint-disable-next-line import/no-cycle
import { updateCampaignState, deleteCampaign } from '@/api/domain/activity'
import CampaignDrawer from './components/CampaignDrawer.vue'

export default {
  name: 'LeaseCampaignList',

  components: {
    CampaignDrawer,
  },

  data() {
    return {
      configData: configDataFn({
        judgePermission: (code) => this.judgePermission(code),
        doView: this.doView,
        doEdit: this.doEdit,
        doOffline: this.doOffline,
        doDelete: this.doDelete,
      }),
      drawerVisible: false,
      drawerMode: 'create',
      selectedCampaignId: null,
      isFirstLoad: true,
    }
  },

  activated() {
    if (this.isFirstLoad) {
      this.isFirstLoad = false
      return
    }
    this.$refs.baseListManagementRef?.reset()
  },

  methods: {
    doCreate() {
      this.drawerMode = 'create'
      this.selectedCampaignId = null
      this.drawerVisible = true
    },

    doView(row) {
      this.drawerMode = 'view'
      this.selectedCampaignId = row.id
      this.drawerVisible = true
    },

    doEdit(row) {
      this.drawerMode = 'edit'
      this.selectedCampaignId = row.id
      this.drawerVisible = true
    },

    onCampaignSaved() {
      this.$refs.baseListManagementRef?.reset()
    },

    doOffline(row) {
      this.$confirm('下线后不可恢复，需重新创建', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { code } = await updateCampaignState({
          id: row.id,
          activityState: -2,
        })
        if (code === 1) {
          this.$message.success('活动已下线')
          this.$refs.baseListManagementRef?.reset()
        }
      }).catch(() => {
        // 用户取消 - drawer stays open
      })
    },
    doDelete(row) {
      this.$confirm('删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { code } = await deleteCampaign({ id: row.id })
        if (code === 1) {
          this.$message.success('活动删除成功')
          this.$refs.baseListManagementRef?.reset()
        }
      }).catch(() => {
        // 用户取消 - drawer stays open
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.operation-box {
  margin-bottom: 16px;
}
</style>
